export default "__VITE_ASSET__CfjC8Vay__"